export const routes = [
  {
    path: "/",
    label: "Home",
    hideBreadcrumb: true,
  },
  {
    path: "/admin/products",
    label: "Products",
    hideBreadcrumb: true,
  },
  {
    path: "/admin/products/:productURLType",
    label: "ProductId",
    breadcrumbParam: "productURLType",
    hideBreadcrumb: true,
    isVirtual: true,
  },
  {
    path: "/admin/products/:productURLType/:productId",
    label: "ProductId",
    breadcrumbParam: "productId",
  },
  {
    path: "/patients",
    label: "Patients",
    hideBreadcrumb: true,
  },
  {
    path: "/patients/:patientId",
    label: "Patients Id",
    breadcrumbParam: "patientId",
    breadcrumb: ({ patient }) => (patient?.firstName ? `${patient?.firstName} ${patient?.lastName ?? ""}` : "Patient"),
    breadcrumbResolver: "patient",
  },
  {
    path: "/admin/patients",
    label: "Patients",
    hideBreadcrumb: true,
  },
  {
    path: "/admin/patients/:patientId",
    label: "Patients Id",
    breadcrumbParam: "patientId",
  },
  {
    path: "/patients/:patientId/assessment",
    label: "Assessment",
    isVirtual: true,
  },
  {
    path: "/patients/:patientId/assessment/:assessmentId",
    label: "Id",
    breadcrumbParam: "assessmentId",
    breadcrumb: ({ assessment }) => (assessment?.title ? `${assessment?.title}` : "Assessment ID"),
    breadcrumbResolver: "assessment",
  },
  {
    path: "/patients/:patientId/assessment/:assessmentId/pdfdownload",
    label: "Download PDF",
  },
  {
    path: "/patients/:patientId/assessment/:assessmentId/mergewoundassessment",
    label: "Merge Wound Assessment",
  },
  {
    path: "/patients/:patientId/assessment/:assessmentId/transferwoundassessment",
    label: "Transfer Wound Assessment",
  },
  {
    path: "/admin/customers",
    label: "Customers",
    hideBreadcrumb: true,
  },
  {
    path: "/admin/customers/:customerId",
    label: "Id",
    breadcrumbParam: "customerId",
    breadcrumb: ({ customer }) => customer?.customerName ?? "Customer",
    breadcrumbResolver: "customer",
  },
  {
    path: "/admin/users",
    label: "Users",
    hideBreadcrumb: true,
  },
  {
    path: "/admin/users/:userId",
    label: "Id",
    breadcrumbParam: "userId",
    breadcrumb: ({ user }) => (user?.firstName ? `${user?.firstName} ${user?.lastName ?? ""}` : "User Name"),
    breadcrumbResolver: "user",
  },
  {
    path: "/admin/sso",
    label: "Sso",
    hideBreadcrumb: true,
  },
  {
    path: "/admin/sso/:ssoId",
    label: "Id",
    breadcrumbParam: "ssoId",
    breadcrumb: ({ sso }) => sso?.domainName ?? "Domain",
    breadcrumbResolver: "sso",
  },
  {
    path: "/admin/FormBuilder",
    label: "Form Builder",
    hideBreadcrumb: true,
  },
  {
    path: "/admin/FormBuilder/:formId",
    label: "Id",
    breadcrumbParam: "formId",
    breadcrumb: ({ form }) => form?.name ?? "Layout Name",
    breadcrumbResolver: "form",
  },
  {
    path: "/content",
    label: "HomeContentViewer",
    hideBreadcrumb: true,
  },
  {
    path: "/home",
    label: "Skin Health",
    hideBreadcrumb: true,
  },
  {
    path: "/worklist",
    label: "WorkList",
    hideBreadcrumb: true,
  },
  {
    path: "/admin/announcement",
    label: "Announcement",
    hideBreadcrumb: true,
  },
  {
    path: "/admin/announcement/:id",
    label: "Id",
    breadcrumbParam: "id",
  },
  {
    path: "/admin/layouts",
    label: "Layouts",
    hideBreadcrumb: true,
  },
  {
    path: "/admin/layouts/:layoutId",
    label: "Id",
    breadcrumbParam: "layoutId",
    breadcrumb: ({ layout }) => layout?.name ?? "Layout Name",
    breadcrumbResolver: "layout",
  },
  {
    path: "/admin/support",
    label: "Contextual Support",
    hideBreadcrumb: true,
  },
  {
    path: "/admin/support/:supportDataId",
    label: "Id",
    breadcrumbParam: "supportDataId",
    breadcrumb: ({ support }) => support?.topic ?? "Topic",
    breadcrumbResolver: "support",
  },
  {
    path: "/userprofile",
    label: "User Profile",
    hideBreadcrumb: true,
  },
  {
    path: "/admin/formulary",
    label: "Formulary",
    hideBreadcrumb: true,
  },
  {
    path: "/admin/formulary/:formularyId",
    label: "View Single Formulary",
    breadcrumbParam: "formularyId",
    breadcrumb: ({ formulary }) => formulary?.data?.formularyName ?? "Formulary Name",
    breadcrumbResolver: "formulary",
  },
  {
    path: "/woundReport",
    label: "Wound Report",
    hideBreadcrumb: true,
  },
  {
    path: "/woundReport/pdfdownload",
    label: "Download PDF",
  },
  {
    path: "/woundReport/activewoundsnotresolved",
    label: "Active Wounds Not Resolved",
  },
  {
    path: "/woundReport/patientwithactivewounds",
    label: "Patient With Active Wounds",
  },
  {
    path: "/biReports",
    label: "BI Reports",
    hideBreadcrumb: true,
  },
  {
    path: "/biReports/biReportsList",
    label: "BI Reports List",
  },
  {
    path: "/treatmentReport",
    label: "Treatment Report",
    hideBreadcrumb: true,
  },
  {
    path: "/treatmentReport/pdfdownload",
    label: "Download PDF",
  },
  {
    path: "/qualityReport",
    label: "Quality Report",
    hideBreadcrumb: true,
  },
  {
    path: "/qualityReport/pdfdownload",
    label: "Download PDF",
  },
  {
    path: "/qualityReport/pendingphotos",
    label: "Missing Photos",
  },
  {
    path: "/qualityReport/pendingassessments",
    label: "Assessments not signed",
  },
  {
    path: "/qualityReport/pendingreviews",
    label: "Assessments not locked",
  },
  {
    path: "/qualityReport/completedassessments",
    label: "Completed Assessments",
  },
  {
    path: "/platformanalytics",
    label: "Platform Analytics",
    hideBreadcrumb: true,
  },
  {
    path: "/platformanalytics/pdfdownload",
    label: "Download PDF",
  },
  {
    path: "/admin/surveyResult",
    label: "Survey",
    hideBreadcrumb: true,
  },
  {
    path: "/admin/usageAnalytics",
    label: "Usage Analytics",
    hideBreadcrumb: true,
  },
  {
    path: "/unAuthorized",
    label: "UnAuthorized Content",
    hideBreadcrumb: true,
  },
  {
    path: "/learnMore",
    label: "Learn More",
    hideBreadcrumb: true,
  },
];

export const headerConfig = {
  "/login": {
    config: { hideHeader: true },
  },
  "/registration": {
    config: { hideHeader: true },
  },
  "/resetpassword": {
    config: { hideHeader: true },
  },
  "/forgotpassword": {
    config: { hideHeader: true },
  },
  "/updatepassword": {
    config: { hideHeader: true },
  },
  "/createpassword": {
    config: { hideHeader: true },
  }, 
  "/status/:type": {
    config: { hideHeader: true },
  }, 
  "/worklist": {
    config: { workListView: true },
  },
  "/admin/formulary/:formularyId": {
    config: { heading: "Admin Portal", subHeading: "Formulary", formulary: true },
  },
  "/platformanalytics": {
    config: { reportHeading: "Platform Analytics" },
  },
  "/qualityReport": {
    config: { reportHeading: "Quality Assurance" },
  },
  "/woundReport": {
    config: { reportHeading: "Wounds Dashboard" },
  },
  "/qualityReport/completedassessments": {
    config: { reportHeading: "Completed Assessments" },
  },
  "/qualityReport/pendingassessments": {
    config: { reportHeading: "Assessments not signed" },
  },
  "/qualityReport/pendingphotos": {
    config: { reportHeading: "Missing Photos" },
  },
  "/qualityReport/pendingreviews": {
    config: { reportHeading: "Assessments not locked" },
  },
  "/biReports": {
    config: { reportHeading: "Ad-hoc Report" },
  },
  "/treatmentReport": {
    config: { reportHeading: "Treatment Outcomes" },
  },
  "/admin/surveyResult": {
    config: { reportHeading: "Survey Results" },
  },
  "/admin/usageAnalytics": {
    config: { reportHeading: "Usage Analytics" },
  },
  "/userprofile": {
    config: { heading: "User Profile" },
  },
  "/woundReport/activewoundsnotresolved": {
    config: { reportHeading: "Active wounds that are not resolved" },
  },
  "/woundReport/patientwithactivewounds": {
    config: { reportHeading: "Patients with active wounds" },
  },
  "/patients": {
    config: { heading: "Patients", patientView: true },
  },
  "/admin/patients": {
    config: { heading: "Patient Management", patientView: true },
  },
  "/admin/patients/:patientId": {
    config: { heading: "Admin", subHeading: "Patient Management" },
  },
  "/admin/customers": {
    config: ({ redux }) => ({
      heading: "Admin Portal",
      subHeading: redux?.customerSubHeading,
    }),
  },
  "/admin/customers/:customerId": {
    config: { heading: "Admin", subHeading: "Customers", type: "CUSTOMER_DETAILS" },
  },
  "/admin/users": {
    config: { heading: "Admin Portal", subHeading: "Users Profile" },
  },
  "/admin/users/:userId": {
    config: { heading: "Admin", subHeading: "User Profile" },
  },
  "/admin/sso": {
    config: { heading: "Admin Portal", subHeading: "SSO" },
  },
  "/admin/sso/:ssoId": {
    config: { heading: "Admin", subHeading: "SSO" },
  },
  "/admin/formBuilder": {
    config: { heading: "Admin Portal", subHeading: "Form Builder" },
  },
  "/admin/formBuilder/:formId": {
    config: ({ redux }) => ({
      heading: "Admin",
      subHeading: redux?.formTitle || "Form Builder",
    }),
  },
  "/admin/announcement": {
    config: { heading: "Admin Portal", subHeading: "Announcement" },
  },
  "/admin/announcement/:id": {
    config: { heading: "Admin", subHeading: "Announcement" },
  },
  "/admin/layouts": {
    config: { heading: "Admin Portal", subHeading: "Layout" },
  },
  "/admin/layouts/:layoutId": {
    config: { heading: "Admin", subHeading: "Layout" },
  },
  "/admin/support": {
    config: { heading: "Admin Portal", subHeading: "Contextual Support" },
  },
  "/admin/support/:supportDataId": {
    config: { heading: "Admin", subHeading: "Contextual Support" },
  },
  "/admin/formulary": {
    config: { heading: "Admin Portal", subHeading: "Formulary" },
  },
  "/admin/products": {
    config: { heading: "Admin Portal", subHeading: "Products" },
  },
  "/admin/products/productfamily/:productId": {
    config: { heading: "Admin", subHeading: "Product Family" },
  },
  "/admin/products/material/:productId": {
    config: { heading: "Admin", subHeading: "Material" },
  },
};
